import React, { Component } from 'react';
import { HomeIcon, MapIcon, MessageSquareIcon, WalletIcon, UserIcon } from 'lucide-react';
interface BottomNavBarProps {
  activeScreen: string;
  onChangeScreen: (screen: string) => void;
}
const BottomNavBar: React.FC<BottomNavBarProps> = ({
  activeScreen,
  onChangeScreen
}) => {
  const navItems = [{
    id: 'home',
    icon: HomeIcon,
    label: 'Home'
  }, {
    id: 'map',
    icon: MapIcon,
    label: 'Map'
  }, {
    id: 'coach',
    icon: MessageSquareIcon,
    label: 'Coach'
  }, {
    id: 'wallet',
    icon: WalletIcon,
    label: 'Wallet'
  }, {
    id: 'profile',
    icon: UserIcon,
    label: 'Profile'
  }];
  return <div className="absolute bottom-0 left-0 right-0 h-20 bg-[#002B36]/80 backdrop-blur-lg border-t border-[#00E4BB]/20 flex items-center justify-around px-2 z-40" data-id="element-13">
      {navItems.map(item => {
      const IconComponent = item.icon;
      const isActive = activeScreen === item.id;
      return <button key={item.id} className={`flex flex-col items-center justify-center p-2 rounded-full transition-all duration-200 ${isActive ? 'text-[#00E4BB]' : 'text-gray-400'}`} onClick={() => onChangeScreen(item.id)} data-id="element-14">
            <IconComponent className={`w-6 h-6 ${isActive ? 'stroke-[#00E4BB]' : 'stroke-gray-400'}`} data-id="element-15" />
            <span className="text-xs mt-1" data-id="element-16">{item.label}</span>
          </button>;
    })}
    </div>;
};
export default BottomNavBar;